const PickUpIcon = ({ width = 28, height = 28, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.83203 16.832V24.9987H22.1654V16.832"
        stroke={color}
        strokeWidth="2.33333"
        strokeLinecap="square"
      />
      <path
        d="M23.4447 5.97794L23.1859 5.16536H22.3331H5.69161H4.84462L4.58231 5.97071L3.65201 8.82687L3.64784 8.83967L3.64397 8.85256C3.59672 9.00984 3.56103 9.17033 3.53725 9.33285L3.53407 9.35457L3.53171 9.37639L3.51429 9.53756L3.50993 9.57789L3.50838 9.61843L3.50215 9.78135L3.50134 9.80271L3.50131 9.82409C3.49991 10.7339 3.86688 11.5963 4.50517 12.2407C5.14136 12.8829 5.9994 13.2626 6.90106 13.3232C7.80252 13.3837 8.70401 13.1227 9.42429 12.5773C9.94444 12.1835 10.345 11.6594 10.5795 11.0612C10.7812 11.5759 11.1067 12.0381 11.529 12.4096C12.1865 12.988 13.0349 13.3099 13.9104 13.3309C14.7859 13.3519 15.6488 13.0712 16.3347 12.5268C16.825 12.1376 17.2026 11.6305 17.4266 11.0557C17.4916 11.2203 17.5695 11.3799 17.6596 11.5334C17.9066 11.954 18.2393 12.3173 18.6336 12.6043C19.0277 12.8911 19.4761 13.0964 19.9502 13.2111C20.4244 13.3257 20.9174 13.3481 21.4 13.2772C21.8827 13.2063 22.3482 13.0431 22.7677 12.7948L22.1734 11.7908L22.7677 12.7948C23.1874 12.5464 23.5538 12.2169 23.8413 11.8231C24.129 11.4291 24.3308 10.9796 24.4305 10.5016C24.5301 10.0234 24.5246 9.53065 24.4142 9.05485L24.4104 9.03849L24.4062 9.02225L24.375 8.9037L24.3674 8.87452L24.3582 8.84578L23.4447 5.97794Z"
        stroke={color}
        strokeWidth="2.33333"
      />
    </svg>
  )
}

export default PickUpIcon
